module.exports = __webpack_public_path__ + "static/img/p-12.7238f56.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p-12.png
// module id = qLpZ
// module chunks = 0